import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Anti Virus Inspection Waivers',
	url: '/forms/anti_virus_inspection_waivers',
	icon: 'archive',
}];

export default class Anti_Virus_Inspection_Waivers extends Framework.Components.View {

	render() {
		let {history,roles} = this.props;

		return (
			<div className="container-fluid">

				<Collections.MandatoryAntiVirusInspectionWaivers
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={roles.includes(UserRoles.Admin)}
				/>

			</div>
		);
	}
}

